import { MIN_WIDTHS } from '@js/constants'

const getDefaultState = () => {
  return {
    timer: 0,
    width: undefined,
    height: undefined,
  };
};

const window = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    isSmall: state => {
      return state.width >= parseInt(MIN_WIDTHS.SMALL);
    },
    isMedium: state => {
      return state.width >= parseInt(MIN_WIDTHS.MEDIUM);
    },
    isLarge: state => {
      return state.width >= parseInt(MIN_WIDTHS.LARGE);
    },
    isExtraLarge: state => {
      return state.width >= parseInt(MIN_WIDTHS.XLARGE);
    },
  },
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
  },
}

export default window;
